<vex-page-layout mode="card">

    <vex-page-layout-header class="pb-16 flex flex-col items-start justify-center">
        <div [class.container]="layoutCtrl.value === 'boxed'"
             [class.px-gutter]="layoutCtrl.value === 'fullwidth'"
             class="w-full flex flex-col sm:flex-row justify-between">
            <div>
                <h1 class="title mt-0 mb-1">Niveles</h1>
                <vex-breadcrumbs
                    [crumbs]="['MENUS.ADMINISTRACION', 'Niveles']"></vex-breadcrumbs>
            </div>
        </div>
    </vex-page-layout-header>

    <vex-page-layout-content class="-mt-6">
        <div>
            <form [formGroup]="searchForm">
                <div class="bg-app-bar px-6 h-16 border-b sticky left-0 flex items-center">
                    <div
                        class="bg-foreground rounded-full px-4 h-10 max-w-[200px] flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                        <input formControlName="code"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               placeholder="Código..."
                               type="search">
                    </div>

                    <div
                        class="bg-foreground rounded-full px-4 h-10 max-w-[200px] ml-2 flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                        <input formControlName="description"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               placeholder="Descripción..."
                               type="search">
                    </div>

                    <div
                        class="bg-foreground rounded-full px-4 h-10 max-w-[120px] ml-2 flex-auto flex items-center border border-gray-300">
                        <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
                        <input formControlName="level"
                               class="px-4 py-2 border-0 outline-none w-full bg-transparent"
                               placeholder="Nivel..."
                               type="number"
                               min="1">
                    </div>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        matTooltip="Buscar"
                        type="button"
                        (click)="buscar()">
                        <mat-icon svgIcon="mat:search"></mat-icon>
                    </button>

                    <span class="flex-1"></span>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        matTooltip="Descargar planilla"
                        (click)="exportToExcel()"
                        type="button">
                        <mat-icon svgIcon="mat:file_download"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="accent"
                        mat-mini-fab
                        matTooltip="Expandir Todo"
                        (click)="expandAll()"
                        type="button">
                        <mat-icon svgIcon="mat:expand_more"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="warn"
                        mat-mini-fab
                        matTooltip="Contraer Todo"
                        (click)="collapseAll()"
                        type="button">
                        <mat-icon svgIcon="mat:expand_less"></mat-icon>
                    </button>

                    <button
                        class="ml-4 flex-none"
                        color="primary"
                        mat-mini-fab
                        matTooltip="Agregar Nivel"
                        (click)="createLevel()"
                        type="button">
                        <mat-icon svgIcon="mat:add"></mat-icon>
                    </button>
                </div>
            </form>

            <table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
                <!-- Columna de Código -->
                <ng-container matColumnDef="code">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.CODIGO" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell class="font-medium">
                        {{ row.code }}
                    </td>
                </ng-container>

                <!-- Columna de Código Completo (jerárquico) -->
                <ng-container matColumnDef="fullCode">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.CODIGO_COMPLETO" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell class="font-medium text-primary">
                        <strong>{{ getFullCode(row) }}</strong>
                    </td>
                </ng-container>

                <!-- Columna de Nivel -->
                <ng-container matColumnDef="level">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.NIVEL" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        {{ row.level }}
                    </td>
                </ng-container>

                <!-- Columna de Descripción con indentación y controles de expansión -->
                <ng-container matColumnDef="description">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.DESCRIPCION" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        <div class="flex items-center" [style.padding-left]="getIndentation(row)">
                            <!-- Botón de expansión/contracción -->
                            <button 
                                *ngIf="hasChildren(row)" 
                                mat-icon-button 
                                class="w-6 h-6 mr-2"
                                (click)="toggleNode(row); $event.stopPropagation()">
                                <mat-icon class="text-secondary" [svgIcon]="row.expanded ? 'mat:expand_less' : 'mat:expand_more'"></mat-icon>
                            </button>
                            
                            <!-- Espaciador para nodos sin hijos -->
                            <span *ngIf="!hasChildren(row)" class="w-6 h-6 mr-2"></span>
                            
                            <!-- Icono del nodo -->
                            <mat-icon class="text-primary mr-2" 
                                     [svgIcon]="!row.parentId ? 'mat:folder' : (row.hasChildren ? 'mat:folder_open' : 'mat:description')">
                            </mat-icon>
                            
                            <!-- Descripción del nodo -->
                            <span>{{ row.description }}</span>
                        </div>
                    </td>
                </ng-container>

                <!-- Columna de Activo -->
                <ng-container matColumnDef="active">
                    <th *matHeaderCellDef class="uppercase" mat-header-cell mat-sort-header>
                        {{ "GRIDS.ACTIVO" | translate }}
                    </th>
                    <td *matCellDef="let row" mat-cell>
                        <mat-icon *ngIf="row.active" svgIcon="mat:check" class="text-green-600"></mat-icon>
                        <mat-icon *ngIf="!row.active" svgIcon="mat:clear" class="text-red-600"></mat-icon>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th *matHeaderCellDef mat-header-cell>{{ "GRIDS.ACCIONES" | translate }}</th>
                    <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
                        <button (click)="$event.stopPropagation()"
                                [matMenuTriggerData]="{ level: row }"
                                [matMenuTriggerFor]="actionsMenu"
                                mat-icon-button
                                type="button">
                            <mat-icon svgIcon="mat:more_horiz"></mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
                <tr *matRowDef="let row; columns: visibleColumns;" @fadeInUp
                    class="hover:bg-hover trans-ease-out cursor-pointer"
                    mat-row></tr>
            </table>

            <mat-paginator 
                [length]="totalRecords"
                [pageSizeOptions]="pageSizeOptions" 
                [pageSize]="pageSize" 
                [pageIndex]="currentPage"
                (page)="pageChanged($event)"
                showFirstLastButtons
                class="sticky left-0"></mat-paginator>

            <!-- Mensaje cuando no hay datos -->
            <div *ngIf="!isLoading && flatNodeList.length === 0" 
                 class="flex flex-col items-center justify-center py-16">
                <mat-icon class="text-6xl text-secondary mb-4" svgIcon="mat:folder_open"></mat-icon>
                <h3 class="text-xl font-medium text-secondary mb-2">
                    No hay niveles
                </h3>
                <p class="text-secondary mb-4">
                    Crea el primer nivel para comenzar
                </p>
                <button mat-raised-button color="primary" (click)="createLevel()">
                    <mat-icon svgIcon="mat:add"></mat-icon>
                    Agregar Nivel
                </button>
            </div>

            <!-- Loading spinner -->
            <div *ngIf="isLoading" class="flex justify-center py-16">
                <mat-spinner></mat-spinner>
            </div>
        </div>
    </vex-page-layout-content>
</vex-page-layout>

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
    <ng-template let-level="level" matMenuContent>
        <button (click)="updateLevel(level)" mat-menu-item>
            <mat-icon svgIcon="mat:edit"></mat-icon>
            <span>{{ "ACTIONS.EDITAR" | translate }}</span>
        </button>
        <button (click)="deleteLevel(level)" mat-menu-item>
            <mat-icon svgIcon="mat:delete"></mat-icon>
            <span>{{ "ACTIONS.ELIMINAR" | translate }}</span>
        </button>
    </ng-template>
</mat-menu>

